import React from 'react';

/**
 * The small numbered kicker above each section heading — a hairline, the
 * section's index, then its name. It is what makes the page read as one
 * sequence rather than a stack of unrelated blocks.
 */
export default function SectionLabel({ index, children, tone = 'dark', align = 'left', className = '' }) {
  const isDark = tone === 'dark';

  return (
    <p
      className={`flex items-center gap-4 font-display text-[0.7rem] uppercase tracking-[0.3em] ${
        align === 'center' ? 'justify-center' : ''
      } ${isDark ? 'text-ink/60' : 'text-cream/60'} ${className}`.trim()}
    >
      <span className={`h-px w-8 ${isDark ? 'bg-ink/25' : 'bg-cream/25'}`} aria-hidden="true" />
      {/* The lighter gold does not carry enough contrast on the cream
          sections, so the number darkens with the background. */}
      <span className={isDark ? 'text-gold-700' : 'text-gold'}>{index}</span>
      <span>{children}</span>
    </p>
  );
}
